const CheckField = ({ checked, onChange, disabled, children, className = '' }) => (
  <label
    className={`flex items-center gap-2 py-1 text-[13px] text-[#353E4A] select-none ${
      disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
    } ${className}`}
  >
    <input type="checkbox" className="peer sr-only" checked={checked} disabled={disabled} onChange={onChange} />
    <span
      aria-hidden="true"
      className={`flex h-[18px] w-[18px] flex-shrink-0 items-center justify-center rounded border transition-colors peer-focus-visible:ring-2 peer-focus-visible:ring-[#B5BDCA] ${
        checked ? 'border-[#27E3A3] bg-[#27E3A3]' : 'border-[#B0B8C4] bg-white'
      }`}
    >
      {checked && (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M2.5 6.2l2.4 2.4 4.6-5" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )}
    </span>
    {children}
  </label>
);

export default CheckField;
